import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import {
  IsBoolean,
  IsHexColor,
  IsInt,
  IsOptional,
  IsString,
  Min,
} from 'class-validator';
import { Transform } from 'class-transformer';

export class CreateActivityCategoryDto {
  @ApiProperty({ description: 'Code unique de la catégorie' })
  @IsString()
  code: string = '';

  @ApiProperty({ description: 'Libellé de la catégorie' })
  @IsString()
  label: string = '';

  @ApiPropertyOptional({ description: 'Description', type: 'string' })
  @IsOptional()
  @IsString()
  description?: string;

  @ApiPropertyOptional({ description: "Icône de la catégorie" })
  @IsOptional()
  @IsString()
  icon?: string;

  @ApiPropertyOptional({ description: 'Couleur hexadécimale' })
  @IsOptional()
  @IsHexColor()
  @Transform(({ value }) => (value === '' ? undefined : value))
  color?: string;

  @ApiPropertyOptional({ description: 'Durée suggérée en minutes' })
  @IsOptional()
  @IsInt()
  @Min(0)
  suggestedDuration?: number;

  @ApiPropertyOptional({ description: 'Nécessite une notation' })
  @IsOptional()
  @IsBoolean()
  requiresGrading?: boolean;
}

